import dayjs from 'dayjs'

const D = dayjs
const Today = D()

export const DatetimeUtils = {
  timestamp() {
    return Today.unix()
  },
  fullYear() {
    return `${Today.year()}`
  },
  yearYY() {
    return `${Today.year().toString().slice(-2)}`
  },
  month() {
    const month = Today.month() + 1

    if (month < 10) {
      return `0${month}`
    }
    return `${month}`
  },
  date() {
    return `${Today.date()}`
  },
  isToday(dateTime: string) {
    return D(dateTime).isSame(Today, 'day')
  },
  YMD(dateTime: string) {
    if (!dateTime) {
      return Today.format('YYMMDD')
    }
    return D(dateTime).format('YYMMDD')
  },
  YMDDot(dateTime: string) {
    if (!dateTime) {
      return Today.format('YYYY.MM.DD')
    }
    return D(dateTime).format('YYYY.MM.DD')
  },
  YMDHyphen(dateTime: string) {
    if (!dateTime) {
      return Today.format('YYYY-MM-DD')
    }
    return D(dateTime).format('YYYY-MM-DD')
  },
  YMDSlash(dateTime: string) {
    if (!dateTime) {
      return Today.format('YYYY/MM/DD')
    }
    return D(dateTime).format('YYYY/MM/DD')
  },
  YMDDotHms(dateTime: string) {
    if (!dateTime) {
      return Today.format('YYYY.MM.DD HH:mm:ss')
    }
    return D(dateTime).format('YYYY.MM.DD HH:mm:ss')
  },
  YMDhms(dateTime: string) {
    if (!dateTime) {
      return Today.format('YYYYMMDDHHmmss')
    }
    return D(dateTime).format('YYYYMMDDHHmmss')
  },
  YMDhmsMS(dateTime?: string) {
    if (!dateTime) {
      return Today.format('YYYYMMDDHHmmssSSS')
    }
    return D(dateTime).format('YYYYMMDDHHmmssSSS')
  },
  MDKr(dateTime: string) {
    if (!dateTime) {
      return Today.format('MM월 DD일')
    }
    return D(dateTime).format('MM월 DD일')
  },
  MDDot(dateTime: string) {
    if (!dateTime) {
      return Today.format('MM.DD')
    }
    return D(dateTime).format('MM.DD')
  },
}
